module.exports = __webpack_public_path__ + "media/logos/cobbles-ffd5a363.png";